module.exports = __webpack_public_path__ + "933f1cdd8c6edab860aae5d4c4890321.svg";